<template>
  <!-- Impostazioni: dati di accesso e consensi, due card affiancate
       (pattern .settings-pair / .settings-card di _pages.scss) -->
  <div class="settings-pair">
    <section class="shadowedCard p-4 settings-card">
      <div class="section-head mb-3">
        <b-icon icon="key" class="section-head__icon" aria-hidden="true"></b-icon>
        <h2 class="section-title mb-0">{{ $t('AccessoEPermessi.datiAccesso') }}</h2>
      </div>
      <p v-if="user.temporary_password" class="text-danger mb-2">
        {{ $t('AccessoEPermessi.modificaPasswordTemporanea') }}
      </p>
      <p v-if="user.expired_password" class="text-danger mb-2">
        {{ $t('AccessoEPermessi.passwordScaduta') }}
      </p>
      <div ref="changePasswordDiv" class="patient-head__grid">
        <div>
          <p class="patient-head__label">Username</p>
          <p class="patient-head__value text-break">{{ user.username }}</p>
        </div>
        <div>
          <p class="patient-head__label">Password</p>
          <p class="patient-head__value" :class="{ 'text-danger': user.temporary_password || user.expired_password }">
            ••••••••
          </p>
        </div>
      </div>
      <div class="settings-card__actions settings-card__actions--top">
        <b-button variant="secondary" size="sm" @click="$refs['modal-pswchange'].show()">
          {{ $t('AccessoEPermessi.cambiaPassword') }}
        </b-button>
      </div>
    </section>

    <section class="shadowedCard p-4 settings-card">
      <div class="section-head mb-3">
        <b-icon icon="shield-check" class="section-head__icon" aria-hidden="true"></b-icon>
        <h2 class="section-title mb-0">{{ $t('AccessoEPermessi.terminiEPrivacy') }}</h2>
      </div>
      <div class="list-stack">
        <div class="list-row">
          <span
            class="list-row__icon"
            :class="user.data_consense ? 'list-row__icon--ok' : 'list-row__icon--no'"
            aria-hidden="true"
          >
            <b-icon :icon="user.data_consense ? 'check-lg' : 'x-lg'"></b-icon>
          </span>
          <div class="list-row__body">
            <p class="list-row__title mb-0">
              {{ user.data_consense ? $t('AccessoEPermessi.visioneTermini') : $t('AccessoEPermessi.revocaTermini') }}
              <a target="_blank" class="text-underlined" :href="infoLinks.paziente">{{ $t('AccessoEPermessi.titoloTermini') }}</a>
            </p>
          </div>
          <b-button size="sm" variant="outline-secondary" @click="revocaConsensoPer('data_consense')">
            {{ $t('AccessoEPermessi.modifica') }}
          </b-button>
        </div>
        <div class="list-row">
          <span
            class="list-row__icon"
            :class="user.charge_consense ? 'list-row__icon--ok' : 'list-row__icon--no'"
            aria-hidden="true"
          >
            <b-icon :icon="user.charge_consense ? 'check-lg' : 'x-lg'"></b-icon>
          </span>
          <div class="list-row__body">
            <p class="list-row__title mb-0">
              {{ user.charge_consense ? $t('AccessoEPermessi.visionePrivacy') : $t('AccessoEPermessi.revocaPrivacy') }}
              <a target="_blank" class="text-underlined" :href="user.type == 1 ? privacyPolicyLinks.operatore : privacyPolicyLinks.paziente">{{ $t('AccessoEPermessi.titoloPrivacy') }}</a>
            </p>
          </div>
          <b-button size="sm" variant="outline-secondary" @click="revocaConsensoPer('charge_consense')">
            {{ $t('AccessoEPermessi.modifica') }}
          </b-button>
        </div>
        <div class="list-row">
          <span
            class="list-row__icon"
            :class="user.share_consense ? 'list-row__icon--ok' : 'list-row__icon--no'"
            aria-hidden="true"
          >
            <b-icon :icon="user.share_consense ? 'check-lg' : 'x-lg'"></b-icon>
          </span>
          <div class="list-row__body">
            <p class="list-row__title mb-0">
              {{ user.share_consense ? $t('AccessoEPermessi.visionati1341') : $t('AccessoEPermessi.revocati1341') }}
              <a target="_blank" class="text-underlined" :href="infoLinks.paziente">{{ $t('AccessoEPermessi.titoloTermini') }}</a>
            </p>
          </div>
          <b-button size="sm" variant="outline-secondary" @click="revocaConsensoPer('share_consense')">
            {{ $t('AccessoEPermessi.modifica') }}
          </b-button>
        </div>
        <div class="list-row">
          <span
            class="list-row__icon"
            :class="user.marketing_consense ? 'list-row__icon--ok' : 'list-row__icon--no'"
            aria-hidden="true"
          >
            <b-icon :icon="user.marketing_consense ? 'check-lg' : 'x-lg'"></b-icon>
          </span>
          <div class="list-row__body">
            <p class="list-row__title mb-0">
              {{ user.marketing_consense ? $t('AccessoEPermessi.acconsentoComunicazioni') : $t('AccessoEPermessi.nonAcconsentoComunicazioni') }}
              <a target="_blank" class="text-underlined" :href="user.type == 1 ? privacyPolicyLinks.operatore : privacyPolicyLinks.paziente">{{ $t('AccessoEPermessi.titoloPrivacy') }}</a>
            </p>
          </div>
          <b-button size="sm" variant="outline-secondary" @click="startConsenseEdit">
            {{ $t('AccessoEPermessi.modifica') }}
          </b-button>
        </div>
      </div>
    </section>

    <b-modal
      id="edit_marketing_consense"
      :title="$t('AccessoEPermessi.titleConsensoComunicazioni')"
      size="lg"
      hide-footer
      centered
    >
      <b-form
        id="change_marketing_permission"
        @submit.prevent="onConsenseSubmit"
        class="px-4 py-2"
      >
        <b-row cols="1" class="text-left">
          <b-form-checkbox
            class="text-font-light-grey"
            name="marketing_consense"
            :value="true"
            :unchecked-value="false"
            v-model="consenseForm.marketing_consense"
          >
            <span class="text-dark"
              >{{$t('AccessoEPermessi.acconsento')}}
              <a
                target="_blank"
                class="text-underlined point"
                href="https://concura.online/privacy.html"
              >
                <u>{{$t('AccessoEPermessi.titoloPrivacy')}}</u></a
              >
            </span>
          </b-form-checkbox>
          <b-form-checkbox
            class="text-font-light-grey"
            name="marketing_consense"
            :value="false"
            :unchecked-value="false"
            v-model="consenseForm.marketing_consense"
          >
            {{$t('AccessoEPermessi.nonAccetto')}}
          </b-form-checkbox>
        </b-row>
        <b-row class="justify-content-end mt-4 px-4">
          <b-button
            class="btn-popup-button ml-2 mr-0"
            @click="$bvModal.hide('edit_marketing_consense')"
            >{{$t('AccessoEPermessi.annulla')}}</b-button
          >
          <b-button class="btn-popup-button ml-2 mr-0" type="submit"
            >{{$t('AccessoEPermessi.salva')}}</b-button
          >
        </b-row>
      </b-form>
    </b-modal>
    <b-modal
      ref="modal-pswchange"
      :title="$t('AccessoEPermessi.titleModificaPassword')"
      size="lg"
      hide-footer
      centered
    >
      <b-form @submit.prevent="submitPswChange">
        <div class="col-12 d-flex flex-wrap">
          <b-form-group
            :label="$t('AccessoEPermessi.passwordAttuale')"
            label-for="oldpsw"
            class="text-left mx-auto col-12"
          >
            <!-- L'occhio dentro al campo, come nell'accesso (.auth__field) -->
            <div class="auth__field">
              <b-form-input
                id="oldpsw"
                v-model="form.old_password"
                :placeholder="$t('AccessoEPermessi.placeholderAttuale')"
                class="pr-5"
                name="oldpsw"
                :type="oldPasswordClear ? 'text' : 'password'"
                autocomplete="current-password"
                required
              ></b-form-input>
              <b-icon
                :icon="oldPasswordClear ? 'eye' : 'eye-slash'"
                font-scale="1.2"
                class="auth__eye"
                role="button"
                tabindex="0"
                :aria-label="$t('AccessoEPermessi.passwordAttuale')"
                @click="oldPasswordClear = !oldPasswordClear"
                @keydown.enter.prevent="oldPasswordClear = !oldPasswordClear"
                @keydown.space.prevent="oldPasswordClear = !oldPasswordClear"
              ></b-icon>
            </div>
          </b-form-group>
        </div>
        <div class="col-12 d-flex flex-wrap">
          <b-form-group
            label="Password*"
            label-for="newpsw"
            class="text-left mx-auto col-12"
          >
            <div class="auth__field">
              <b-form-input
                id="newpsw"
                class="pr-5"
                name="password"
                :type="passwordClear ? 'text' : 'password'"
                v-model="form.password"
                placeholder="Password..."
                autocomplete="new-password"
                :state="form.password == null ? null : validatePassword"
                required
              >
              </b-form-input>
              <b-icon
                :icon="passwordClear ? 'eye' : 'eye-slash'"
                font-scale="1.2"
                class="auth__eye"
                role="button"
                tabindex="0"
                aria-label="Password"
                @click="passwordClear = !passwordClear"
                @keydown.enter.prevent="passwordClear = !passwordClear"
                @keydown.space.prevent="passwordClear = !passwordClear"
              ></b-icon>
            </div>
          </b-form-group>
          <b-form-group
            :label="$t('AccessoEPermessi.confermaPassword')" 
            label-for="confpsw"
            class="text-left mx-auto col-12"
          >
            <div class="auth__field">
              <b-form-input
                id="confpsw"
                class="pr-5"
                name="password_confirmation"
                :type="passwordConfirmationClear ? 'text' : 'password'"
                v-model="form.password_confirmation"
                :placeholder="$t('AccessoEPermessi.placeholderConferma')"
                autocomplete="new-password"
                :state="form.password_confirmation == null ? null : validateConfirm"
                required
              ></b-form-input>
              <b-icon
                :icon="passwordConfirmationClear ? 'eye' : 'eye-slash'"
                font-scale="1.2"
                class="auth__eye"
                role="button"
                tabindex="0"
                :aria-label="$t('AccessoEPermessi.confermaPassword')"
                @click="passwordConfirmationClear = !passwordConfirmationClear"
                @keydown.enter.prevent="passwordConfirmationClear = !passwordConfirmationClear"
                @keydown.space.prevent="passwordConfirmationClear = !passwordConfirmationClear"
              ></b-icon>
            </div>
          </b-form-group>
          <p class="text-left text-medium-grey fs-6">
            {{$t('AccessoEPermessi.requisitiPassword', { count: config.passwordHistoryDepth })}}
          </p>
        </div>
        <div class="col-12 form-actions form-actions--end my-3">
          <b-button
            type="button"
            variant="popup-button"
            @click="resetForm"
            >{{$t('AccessoEPermessi.annullaOperazione')}}</b-button
          >
          <b-button
            type="submit"
            variant="popup-button"
            :disabled="!enableSecondBtn"
          >
            {{$t('AccessoEPermessi.confermaModifica')}}</b-button
          >
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="revoca_permesso"
      centered
      :title="revoca[revocaConsenso]"
      :ok-title="$t('AccessoEPermessi.siRevoca')"
      ok-variant="popup-button"
      :cancel-title="$t('AccessoEPermessi.noAnnulla')"
      cancel-variant="popup-button"
      footer-border-variant="white"
      @ok="submitRevoca"
      @cancel="$bvModal.hide('revoca_permesso')"
    >
      <h6>
        {{$t('AccessoEPermessi.revocaNecessaria')}}
      </h6>
      <p>{{$t('AccessoEPermessi.desideriRevoca')}}</p>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { cittadinoService } from "@/_services";
import config from "@/_config/config";

export default {
  name: "AccessoEPermessi",
  components: {},
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
    validatePassword() {
      if (this.form.password) {
        if (
          this.form.old_password &&
          this.form.old_password === this.form.password
        ) {
          return false;
        }
        this.has_minimum_lenth = this.form.password.length >= 8;
        this.has_number = /\d/.test(this.form.password);
        this.has_lowercase = /[a-z]/.test(this.form.password);
        this.has_uppercase = /[A-Z]/.test(this.form.password);
        this.has_special = /[^\p{L}\p{N}\s]/u.test(this.form.password);
        
        // Controllo null-safe per name e surname
        const userName = this.user.anagrafica?.name || '';
        const userSurname = this.user.anagrafica?.surname || '';
        
        if (userName) {
          this.has_name = !this.form.password.toLowerCase().includes(userName.toLowerCase());
        } else {
          this.has_name = true;
        }
        
        if (userSurname) {
          this.has_surname = !this.form.password.toLowerCase().includes(userSurname.toLowerCase());
        } else {
          this.has_surname = true;
        }
        
        return (
          this.has_minimum_lenth &&
          this.has_number &&
          this.has_lowercase &&
          this.has_uppercase &&
          this.has_name &&
          this.has_surname &&
          this.has_special
        );
      }
      return false;
    },
    validateConfirm() {
      if (this.form.password) {
        return this.form.password_confirmation === this.form.password;
      }
      return false;
    },
    enableSecondBtn() {
      if (this.form.old_password !== null) {
        if (this.validatePassword && this.validateConfirm) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  data() {
    return {
      config: config,
      password: "password...",
      form: {
        old_password: null,
        password: null,
        password_confirmation: null,
      },
      infoLinks: {
        paziente: process.env.VUE_APP_LINK_TC_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_TC_OPERATORE,
      },
      privacyPolicyLinks: {
        paziente: process.env.VUE_APP_LINK_INFORMATIVA_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_INFORMATIVA_OPERATORE,
      },
      consenseForm: {
        marketing_consense: false,
      },
      oldPasswordClear: false,
      passwordClear: false,
      passwordConfirmationClear: false,
      revocaConsenso: null,
      revoca: {
        data_consense: this.$t('AccessoEPermessi.revoca.data_consense'),
        share_consense: this.$t('AccessoEPermessi.revoca.share_consense'),
        charge_consense: this.$t('AccessoEPermessi.revoca.charge_consense')
      }
    };
  },
  methods: {
    ...mapActions("utente", [
      "me",
      "changePassword",
      "setAnagrafica",
      "setTemporaryPasswordFalse",
      "setExpiredPasswordFalse",
    ]),
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    resetForm() {
      this.$refs["modal-pswchange"].hide();
      this.form = {
        old_password: null,
        password: null,
        password_confirmation: null,
      };
    },
    submitRevoca() {
      var form = {};
      form[this.revocaConsenso] = false;
      const self = this;
      cittadinoService
        .updateConsense(form)
        .then(function (res) {
          self.me();
          self.$bvModal.hide("revoca_permesso");
          self.successAlert(self.$t('AccessoEPermessi.successModifica'));
          self.waitAndRedirect();
        })
        .catch(function (err) {
          self.$bvModal.hide("revoca_permesso");
          self.errorAlert(self.$t('AccessoEPermessi.erroreModifica'));
        });
    },
    waitAndRedirect() {
      const self = this;
      window.setTimeout(function () {
        self.$router.push({ name: "Home" });
      }, 3000);
    },
    submitPswChange() {
      const self = this;
      this.changePassword(this.form).then(function () {
        window.scrollTo(0, 0);
        self.resetForm();
        self.setTemporaryPasswordFalse();
        self.setExpiredPasswordFalse();
        self.me();
      });
    },
    revocaConsensoPer(consenso) {
      this.revocaConsenso = consenso;
      this.$bvModal.show("revoca_permesso");
    },
    startConsenseEdit() {
      this.consenseForm.marketing_consense = this.user.marketing_consense;
      this.$bvModal.show("edit_marketing_consense");
    },
    onConsenseSubmit() {
      const self = this;
      cittadinoService
        .updateConsense(this.consenseForm)
        .then(function (res) {
          self.me();
          self.$bvModal.hide("edit_marketing_consense");
          self.successAlert(self.$t('AccessoEPermessi.successModifica'));
        })
        .catch(function (err) {
          self.$bvModal.hide("edit_marketing_consense");
          self.errorAlert(self.$t('AccessoEPermessi.erroreModifica'));
        });
    },
  },
  watch: {},
  created() {
    this.me();
    if (this.$route.query.scope === "temporary") {
      this.$nextTick(function () {
        this.$refs["changePasswordDiv"].scrollIntoView();
        this.infoAlert(this.$t('AccessoEPermessi.modificaPasswordTemp'));
      });
    }
    if (this.$route.query.scope === "expired") {
      this.$nextTick(function () {
        this.$refs["changePasswordDiv"].scrollIntoView();
        this.infoAlert(this.$t('AccessoEPermessi.passwordScadutaCambio'));
      });
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
</style>
